import {
  ExpandedTable,
  Layout,
  NotFound,
  Spinner,
  TextField,
} from "../../../ui-kit";
import { getListOfRoles, useGetPermissionsMatrix } from "./features/queries";

import { EntitiMatrixTable } from "./components/EntitiMatrixTable";
import Header from "../../ControlTer/components/Header";
import HelperComponents from "./components/HelperComponents";
import { MatrixModel } from "./types";
import Paths from "../../../constants/PathsBreadcrumbs";
import { useBreadcrumbs } from "../../../hooks/useBreadcrumbs";
import { useColumns } from "../../../hooks/useColumns";
import { useDebouncedValue } from "../../../hooks/useDebouncedValue";
import { Link } from "react-router-dom";
const columns = [
  {
    title: "Наименование раздела",
    dataIndex: "moduleName",
    align: "left",
  },
];

export const Matrix = () => {
  const cols = useColumns<MatrixModel>(columns);

  const {
    value: searchTerm,
    setValue: setSearchTerm,
    debouncedValue: debouncedSearchTerm,
  } = useDebouncedValue();

  const {
    value: searchRoleTerm,
    setValue: setSearchRoleTerm,
    debouncedValue: debouncedSearchRoleTerm,
  } = useDebouncedValue();

  const { data: roles = [] } = getListOfRoles(debouncedSearchRoleTerm);

  const {
    data = [],
    isError,
    isLoading,
  } = useGetPermissionsMatrix(debouncedSearchTerm);

  useBreadcrumbs(Paths.adminMatrix);

  return (
    <Layout type="white">
      <Link
        to="/pdf/Rukovodstvo_sistemnogo_programmista.pdf"
        target="_blank"
        download
      >
        Скачать руководство системного программиста
      </Link>
      <br></br>
      <Link to="/pdf/Opisanie_matricy.pdf" target="_blank" download>
        Скачать описание матрицы
      </Link>
      <HelperComponents.GridContainer>
        <Header title="Матрица прав" className="head" />

        <TextField
          value={searchTerm}
          onChange={setSearchTerm}
          label="Поиск по подразделу"
          className="searchfieldPermissions"
          isClearable
          isSearchField
        />

        <TextField
          value={searchRoleTerm}
          onChange={setSearchRoleTerm}
          label="Поиск по роли"
          className="searchfieldRole"
          isClearable
          isSearchField
        />
      </HelperComponents.GridContainer>

      {isLoading ? (
        <Spinner size="large" />
      ) : (
        <>
          {isError ? (
            <NotFound />
          ) : (
            <>
              <ExpandedTable<MatrixModel>
                columns={cols}
                data={data}
                rowKey={(row) => row.moduleName}
                expandedRowRender={(r) => (
                  <EntitiMatrixTable matrixChild={r} roles={roles} />
                )}
                scroll={!data?.length ? null : { x: "auto" }}
              />
            </>
          )}
        </>
      )}
    </Layout>
  );
};
